import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import React from 'react';
import { APP_BASE_URL } from 'src/features/shared/data/app-settings';
import { useNavigate } from 'react-router-dom';
import { appPages, OptionType } from '../menu-options';
import AppRoutes from 'src/features/router/data/app-routes';

const appName = 'Backoffice';

const CompactAppMenu = () => {
    const navigate = useNavigate();
    const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(null);

    const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorElNav(event.currentTarget);
    };
    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    const handleItemClick = (option: OptionType) => {
        navigate(option.path);
        setAnchorElNav(null);
    };

    return (
        <>
            <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
                <IconButton
                    size="large"
                    aria-label="application menu"
                    aria-controls="menu-appbar"
                    aria-haspopup="true"
                    onClick={handleOpenNavMenu}
                    color="inherit"
                >
                    <MenuIcon />
                </IconButton>
                <Menu
                    id="menu-appbar"
                    anchorEl={anchorElNav}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    keepMounted
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                    open={Boolean(anchorElNav)}
                    onClose={handleCloseNavMenu}
                    sx={{
                        display: { xs: 'block', md: 'none' },
                    }}
                >
                    {appPages.map((option) => (
                        <MenuItem key={option.name} onClick={() => handleItemClick(option)}>
                            <Typography textAlign="center">{option.name}</Typography>
                        </MenuItem>
                    ))}
                </Menu>
            </Box>
            <Typography
                variant="h5"
                noWrap
                component="a"
                href={APP_BASE_URL + AppRoutes.rootPath}
                sx={{
                    display: { xs: 'flex', md: 'none' },
                    flexGrow: 1,
                    color: 'inherit',
                    textDecoration: 'none',
                }}
            >
                {appName}
            </Typography>
        </>
    );
};

const BigAppMenu = () => {
    const navigate = useNavigate();
    const onMenuClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        const path = event.currentTarget.value;
        navigate(path);
    };
    return (
        <>
            <Typography
                variant="h6"
                noWrap
                component="a"
                href={APP_BASE_URL + AppRoutes.rootPath}
                sx={{
                    mr: 2,
                    display: { xs: 'none', md: 'flex' },
                    color: 'inherit',
                    textDecoration: 'none',
                }}
            >
                {appName}
            </Typography>

            <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
                {appPages.map((option) => (
                    <Button
                        key={option.name}
                        value={option.path}
                        onClick={onMenuClick}
                        sx={{ my: 2, color: 'white', display: 'block' }}
                    >
                        {option.name}
                    </Button>
                ))}
            </Box>
        </>
    );
};

const ResponsiveAppMenu = () => (
    <>
        <CompactAppMenu />
        <BigAppMenu />
    </>
);

export default ResponsiveAppMenu;
